import axios from "axios/index";

export default {
  fetchEvents: ({commit}, params) => {
    const cb = params['cb'];
    commit('ui/SHOW_OVERLAY', true, {root: true});
    const arr = [];
    Object.keys(params).forEach(key => {
      if (typeof params[key] !== 'undefined' && key !== "cb") {
        if (typeof params[key] === 'object') {
          arr.push(key + '=' + JSON.stringify(params[key]));
        } else {
          arr.push(key + '=' + params[key]);
        }
      }
    });
    const queryParams = arr.length > 0 ? `?${arr.join('&')}` : '';
    axios({
      url: `/engine/events${queryParams}`
    })
      .then((response) => {
        commit('events/SET_EVENTS', response.data, {root: true});
        commit('ui/HIDE_OVERLAY', true, {root: true});
        if (typeof cb === 'function') {
          try {
            cb();
          } catch (e) {
            /* eslint-disable */
            console.log(e);
          }
        }
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
        commit('ui/HIDE_OVERLAY', true, {root: true});
      });
  }
};